import * as React from "react"
import {
    Card as MuiCard,
    CardHeader as MuiCardHeader,
    CardContent as MuiCardContent,
    CardActions,
    Typography,
} from "@mui/material"

// Card wrapper
const Card = React.forwardRef(({ className, ...props }, ref) => (
    <MuiCard
        elevation={0}
        sx={{ boxShadow: "none", borderRadius: "12px", }}
        ref={ref}
        className={className}
        {...props}
    />
))
Card.displayName = "Card"

// CardHeader wrapper
const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
    <MuiCardHeader
        ref={ref}
        className={"flex flex-col space-y-1.5 p-6 " + (className || "")}
        {...props}
    />
))
CardHeader.displayName = "CardHeader"

// CardTitle
const CardTitle = React.forwardRef(({ className, children, ...props }, ref) => (
    <Typography
        ref={ref}
        variant="h6"
        component="div"
        className={
            "text-2xl font-semibold leading-none tracking-tight " + (className || "")
        }
        {...props}
    >
        {children}
    </Typography>
))
CardTitle.displayName = "CardTitle"

// CardDescription
const CardDescription = React.forwardRef(
    ({ className, children, ...props }, ref) => (
        <Typography
            ref={ref}
            variant="body2"
            color="textSecondary"
            className={"text-sm text-muted-foreground " + (className || "")}
            {...props}
        >
            {children}
        </Typography>
    )
)
CardDescription.displayName = "CardDescription"

// CardContent wrapper
const CardContent = React.forwardRef(({ className, ...props }, ref) => (
    <MuiCardContent
        ref={ref}
        className={"p-6 pt-0 " + (className || "")}
        {...props}
    />
))
CardContent.displayName = "CardContent"

// CardFooter → maps to MUI CardActions
const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
    <CardActions
        ref={ref}
        className={"flex items-center p-6 pt-0 " + (className || "")}
        {...props}
    />
))
CardFooter.displayName = "CardFooter"

export {
    Card,
    CardHeader,
    CardFooter,
    CardTitle,
    CardDescription,
    CardContent,
}
